import * as z from 'zod';

import { priceFrequencyQueryLinkerSchema } from '@/_pages/settings/price-frequencies/shared/schemas/price-frequency-query-linker-schema';
import { unitSellBysQueryLinkerSchema } from '@/_pages/settings/unit-sell-bys/shared/schemas';
import { booleanFormSchema, currencyInput } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { productAndServicesCategoryLinkerSchema, productAndServicesQuerySchema } from './product-services-query-schema';

export const productAndServicesFormSchema = productAndServicesQuerySchema
  .omit({
    name: true,
    category_id: true,
    price_frequency_id: true,
    unit_sell_by_id: true,
    manufacturer_id: true,
  })
  .extend({
    name: z.string().min(3),
    sku: z.string(),
    type: z.string(),
    status: statusFormSchema,
    description: z.string(),

    client_qty_set: booleanFormSchema(),
    wholesale_manual: booleanFormSchema(),

    product_expires: booleanFormSchema(),
    client_opt: booleanFormSchema(),
    virtual_product: booleanFormSchema(),

    list_price: currencyInput.formSchema(),
    landed_cost: currencyInput.formSchema(),
    wholesale_price: currencyInput.formSchema(),
    list_price_profit: currencyInput.formSchema(),
    wholesale_profit: currencyInput.formSchema(),

    category: productAndServicesCategoryLinkerSchema.refine((v) => v.id !== -1, {
      message: 'Category is required',
    }),
    price_frequency: priceFrequencyQueryLinkerSchema.refine((v) => v.id !== -1, {
      message: 'Price frequency is required',
    }),
    unit_sell_by: unitSellBysQueryLinkerSchema.refine((v) => v.id !== -1, {
      message: 'Unit Sell By is required',
    }),
  });

export type ProductAndServicesFormSchema = z.infer<typeof productAndServicesFormSchema>;
